export default __webpack_public_path__ + "static/media/icon-lung.9bc32296.svg";